import useRequest from '@/websdk/utils/request';
import { useEffect, useState } from 'react';
import { useDevExtraHiveSn } from '@/server';
import { MqttApi } from '@/utils/paho_mqtt';
import uuid from 'react-uuid';

export default (function (params) {
  const { isRequestSuccessed, data, isLoading, exec } = useRequest({
    url: '',
    name: 'alarmsAnalysisGet',
    method: 'GET',
  });
  const page_uid = uuid();
  const [machid, setMachid] = useState();
  const [hiveSn, isHiveSnSuccess] = useDevExtraHiveSn(machid);
  const [hiveCount, setHiveCount] = useState(0);
  const [successCount, setSuccessCount] = useState(0);
  const [successRsp, setSuccessRsp] = useState({ record: [], statistics: [] });
  const [totalRsp, setTotalRsp] = useState({ record: [], statistics: [] });
  const [result, setResult] = useState({});
  useEffect(() => {
    if (isHiveSnSuccess) {
      if (hiveSn) {
        if (JSON.stringify(hiveSn) !== '{}') {
          var count = Object.keys(hiveSn).length;
          setHiveCount(count);
          for (let k in hiveSn) {
            MqttApi.subscriptionApi(
              {
                topic: 'alarm-rsp-' + k + '-' + page_uid,
              },
              res => {
                if (res.data.data) {
                  if (count === 1) {
                    //setIsSucc(true);
                    setSuccessRsp(res.data.data);
                  } else {
                    setSuccessRsp(res.data.data);
                  }
                } else {
                  if (count === 1) {
                    setIsSucc(true);
                    setRsp({ record: [], statistics: [] });
                  } else {
                    setSuccessRsp({ record: [], statistics: [] });
                  }
                }
                var res_ = JSON.parse(JSON.stringify(result));
                res_[k] = true;
                setResult(res_);
              }
            );
            MqttApi.publishApi({
              topic: 'alarm-req-' + k,
              payload: {
                device_ids: hiveSn[k].toString(),
                start: params.start,
                end: params.end,
                id: page_uid,
              },
            });
          }
        } else {
          setRsp({ record: [], statistics: [] });
          setIsSucc(true);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hiveSn, isHiveSnSuccess]);

  /* useEffect(() => {
    if (successCount) {
      console.log('succCOunt', successCount, result);
      var total = JSON.parse(JSON.stringify(totalRsp));
      if (successCount < hiveCount) {
        total.record = total.record.concat(successRsp.record);
        setTotalRsp(total);
      } else {
        total.record = total.record.concat(successRsp.record);
        setRsp(total);
        setIsSucc(true);
        setHiveCount(0);
        setSuccessCount(0);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successCount]); */

  useEffect(() => {
    if (JSON.stringify(result) !== '{}') {
      var total = JSON.parse(JSON.stringify(totalRsp));
      var ct = successCount + 1;
      setSuccessCount(ct);

      if (ct < hiveCount) {
        total.record = total.record.concat(successRsp.record);
        setTotalRsp(total);
      } else {
        total.record = total.record.concat(successRsp.record);
        setRsp(total);
        setIsSucc(true);
        setHiveCount(0);
        setSuccessCount(0);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result]);

  const [rsp, setRsp] = useState({ record: [], statistics: [] });
  const [isSucc, setIsSucc] = useState();
  useEffect(() => {
    if (data) {
      setRsp(data);
      setIsSucc(isRequestSuccessed);
    }
  }, [data, isRequestSuccessed]);
  useEffect(() => {
    if (params) {
      if (localStorage.model === '2') {
        setMachid({ device_ids: params.device_ids });
      } else {
        let url = `/api/alarms/analysis`;
        Object.keys(params).forEach((key, index) => {
          if (index === 0) {
            url += '?';
          } else {
            url += '&';
          }
          url += `${key}=${params[key]}`;
        });
        exec(url);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return [isSucc, rsp || [], isLoading, exec];
});
